import { Component, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss'],
})
export class EventsPageComponent implements OnInit {
  screenSize = ScreenType;
  constructor(private marketplaceService:MarketplaceService) {}

  ngOnInit() {
    this.marketplaceService.fetchMarketplaceItems().toPromise();
  }
}
